/** @format */

import React, { useState, useEffect } from 'react';
import FormInput from '../form-input/form-input.component';
import Modal from '../modal/modal.component';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
// import Multiselect from 'multiselect-react-dropdown';
import CustomButton from '../custom-button/custom-button.component';
import {
  selectLocalDistros,
  selectNewHireFirstName,
  selectNewHireLastName,
  selectNewHireLocalDistros,
  selectNewHireDoh,
  selectNewHireDepartment,
  selectNewHirePosition,
  selectNewHireLocation,
  selectAzureGroups,
  selectGoogleGroups,
  selectNavitaire,
  selectNoc,
  selectNewHireUber,
  selectNewHireLyft,
  selectNewHireDepartmentTailMapping,
  selectNewHireExpensePolicyMapping,
  selectNewHireInvoiceGroupMapping,
} from '../../redux/new-hire/new-hire.selector';

import {
  setNewHireFirstName,
  setNewHireLastName,
  setNewHireLocalDistros,
  setNewHireDoh,
  setNewHireLocation,
} from '../../redux/new-hire/new-hire.actions';
import { Box, Container } from '@mui/material';
import { socket } from '../../utils/socketIo';
import './newhire-form.styles.css';

const NewHireForm = ({
  localDistros,
  googleGroups,
  azureGroups,
  currDepartment,
  currPosition,
  newHireFirstName,
  newHireLastName,
  newHireLocalDistros,
  location,
  doh,
  noc,
  uber,
  lyft,
  navitaire,
  setFirstName,
  setLastName,
  setDoh,
  setLocation,
  setLocalDistros,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const [accCreationMessages, setMessage] = useState([]);
  const [accType, setAccType] = useState('google');

  const closeModal = () => {
    setIsOpen(false);
    // * Reset update messages array
    // setMessage([]);
  };
  useEffect(() => {
    socket.on('GoogleAccountCreationUpdate', (data) => {
      setMessage((oldArray) => [...oldArray, data]);
      setIsOpen(true);
    });

    socket.on('AzureAccountCreationUpdate', (data) => {
      setMessage((oldArray) => [...oldArray, data]);
      setIsOpen(true);
    });

    socket.on('NocAccountCreationUpdate', (data) => {
      setMessage((oldArray) => [...oldArray, data]);
      setIsOpen(true);
    });

    socket.on('NavitaireAccountCreationUpdate', (data) => {
      setMessage((oldArray) => [...oldArray, data]);
      setIsOpen(true);
    });

    socket.on('AzureAuthUrl', () => {
      setAccType('azure');
    });

    socket.on('GoogleAuthUrl', () => {
      setAccType('google');
    });

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGoogleFlow = () => {
    socket.emit('GoogleAuthCode', {
      firstName: newHireFirstName.toLowerCase().trim(),
      lastName: newHireLastName.toLowerCase().trim(),
      department: currDepartment,
      position: currPosition,
      doh: doh,
      noc: noc,
      navitaire: navitaire,
      uber: uber,
      lyft: lyft,
      googleGroups: googleGroups.concat(newHireLocalDistros),
      azureGroups: azureGroups,
      locationCode: location,
    });
  };

  const handleAzureFlow = () => {
    socket.emit('CreateAzureAcc', {
      firstName: newHireFirstName.toLowerCase().trim(),
      lastName: newHireLastName.toLowerCase().trim(),
      department: currDepartment,
      position: currPosition,
      doh: doh,
      noc: noc,
      navitaire: navitaire,
      uber: uber,
      lyft: lyft,
      googleGroups: googleGroups.concat(newHireLocalDistros),
      azureGroups: azureGroups,
      distros: newHireLocalDistros,
      locationCode: location,
    });
  };

  const handleNocFlow = () => {
    socket.emit('CreateNocAcc', {
      firstName: newHireFirstName,
      lastName: newHireLastName,
      doh: doh,
      department: currDepartment,
      position: currPosition,
      noc: noc,
      navitaire: navitaire,
    });
  };

  const handleNavitaireFlow = () => {
    socket.emit('CreateNavitaireAccount', {
      firstName: newHireFirstName,
      lastName: newHireLastName,
      doh: doh,
      department: currDepartment,
      position: currPosition,
      noc: noc,
      navitaire: navitaire,
      locationCode: location,
    });
  };

  const handleAllFlow = () => {
    // if (noc && noc.account) {
    //   handleNocFlow();
    // }
    // handleGoogleFlow();
    handleAzureFlow();
    // socket.emit('TestGoogleFunctions');
  };
  const handleSubmit = (event) => {
    event.preventDefault();

    switch (accType) {
      case 'google':
        handleGoogleFlow();
        return;
      case 'azure':
        handleAzureFlow();
        return;
      case 'noc':
        handleNocFlow();
        break;
      case 'navitaire':
        handleNavitaireFlow();
        break;
      case 'all':
        handleAllFlow();
        break;

      default:
        break;
    }
  };

  // const onDistroChange = (selectedList) => {
  //   // if (selectedList.length < 1) {
  //   //   return;
  //   // }
  //   setLocalDistros(selectedList);
  // };

  const handleChange = (event) => {
    const { value, name } = event.target;

    switch (name) {
      case 'firstName':
        setFirstName(value);
        break;
      case 'lastName':
        setLastName(value);
        break;
      case 'doh':
        setDoh(value);
        break;
      case 'location':
        setLocation(value);
        break;
      default:
        break;
    }
  };

  return (
    <Box>
      <form onSubmit={handleSubmit}>
        <Container
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <FormInput
            name="firstName"
            type="text"
            handleChange={handleChange}
            value={newHireFirstName !== null ? newHireFirstName : ''}
            label="First Name"
            className="nh_input"
            id="nhFirst"
            style={{ marginRight: '20px' }}
            required
          />
          <FormInput
            name="lastName"
            type="text"
            handleChange={handleChange}
            value={newHireLastName !== null ? newHireLastName : ''}
            // style={{ marginLeft: '20px' }}
            className="nh_input"
            id="nhLast"
            label="Last Name"
            required
          />
        </Container>
        <Container
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          }}
        ></Container>

        <FormInput
          name="doh"
          type="date"
          handleChange={handleChange}
          value={doh !== null ? doh : ''}
          label="Date of Hire"
          id="doh"
          required
        />

        <FormInput
          name="location"
          type="text"
          handleChange={handleChange}
          value={location !== null ? location : ''}
          label="Location Code"
          id="nhLoc"
          className="nh_input"
          required
        />

        <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
          <CustomButton
            type="submit"
            name="azure"
            onClick={() => {
              setAccType('all');
            }}
            style={{ margin: '20px' }}
          >
            Submit
          </CustomButton>
          {/* <CustomButton
            type="submit"
            name="google"
            onClick={() => {
              setAccType('google');
            }}
            style={{ margin: '20px' }}
          >
            Create Google
          </CustomButton>
          <CustomButton
            type="submit"
            name="azure"
            onClick={() => {
              setAccType('azure');
            }}
            style={{ margin: '20px' }}
          >
            Create Azure
          </CustomButton>

          {noc && noc.account && (
            <CustomButton
              type="submit"
              name="noc"
              onClick={() => {
                setAccType('noc');
              }}
              style={{ margin: '20px' }}
            >
              Create NOC
            </CustomButton>
          )} */}

          {/* {navitaire && navitaire.account && (
            <CustomButton
              type="submit"
              name="navitaire"
              onClick={() => {
                setAccType('navitaire');
              }}
              style={{ margin: '20px' }}
            >
              Create Navitaire
            </CustomButton>
          )} 
          <Multiselect
            isObject={false}
            options={localDistros}
            avoidHighlightFirstOption={true}
            selectedValues={newHireLocalDistros}
            showArrow={true}
            showCheckbox={true}
            closeOnSelect={false}
            keepSearchTerm={true}
            placeholder="Select Distros"
            onSelect={onDistroChange}
            onRemove={onDistroChange}
            style={{
              chips: {
                background: 'red',
                color: 'white',
                fontWeight: 'bold',
              },
              option: { fontSize: '15px' },
              searchBox: {
                backgroundColor: 'white',
                borderBottom: '1px solid black',
              },
              groupHeading: {
                fontWeight: 'bold',
                color: 'white',
                fontSize: '20px',
                backgroundColor: 'red',
                padding: '3px',
              },
              optionContainer: {
                // To change css for option container
                height: '200px',
              },
            }}
            id="multiSelectDistors"
          ></Multiselect>
          */}
        </Box>

        {/* <CustomButton type="button"> Cancel </CustomButton> */}
      </form>

      {isOpen && (
        <Modal
          modalOpen={isOpen}
          handleClose={closeModal}
          text={`Account Creation Updates`}
          type="dropIn"
          data={accCreationMessages}
          variant={'accCreationStatus'}
        />
      )}
    </Box>
  );
};

const mapStateToProps = createStructuredSelector({
  localDistros: selectLocalDistros,
  newHireFirstName: selectNewHireFirstName,
  newHireLastName: selectNewHireLastName,
  newHireLocalDistros: selectNewHireLocalDistros,
  currDepartment: selectNewHireDepartment,
  currPosition: selectNewHirePosition,
  doh: selectNewHireDoh,
  azureGroups: selectAzureGroups,
  googleGroups: selectGoogleGroups,
  noc: selectNoc,
  uber: selectNewHireUber,
  lyft: selectNewHireLyft,
  navitaire: selectNavitaire,
  location: selectNewHireLocation,
  expenseMapping: selectNewHireExpensePolicyMapping,
  invoiceMapping: selectNewHireInvoiceGroupMapping,
  departmentTailMapping: selectNewHireDepartmentTailMapping,
});

const mapDispatchToProps = (dispatch) => ({
  setFirstName: (firstName) => dispatch(setNewHireFirstName(firstName)),
  setLastName: (lastName) => dispatch(setNewHireLastName(lastName)),
  setDoh: (doh) => dispatch(setNewHireDoh(doh)),
  setLocation: (loc) => dispatch(setNewHireLocation(loc)),
  setLocalDistros: (localDistros) =>
    dispatch(setNewHireLocalDistros(localDistros)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewHireForm);
